export default function FaqData() {
  return {
    title: "Things to know…",
    description: "People just like you have questions about Term Life Insurance. Here are a few answers that might help.",
    faqs: [
      {
        title: "Will I need to undergo a medical exam?",
        description: "It depends on the insurer and the coverage amount you apply for. Some providers may require a medical exam, while others offer no-exam policies based on your age and health status. You can typically find out during the application process.",
      },
      {
        title: "How long does it take to get approved for life insurance coverage?",
        description: "Approval times can vary. For no-exam policies, you may receive a decision within minutes to a few days. For policies requiring medical exams or additional underwriting, it could take several days to a few weeks.",
      },
      {
        title: "Is there a waiting period before coverage begins?",
        description: "Coverage typically begins once your policy is issued and the first premium payment is made, though some insurers may have specific waiting periods for certain conditions. Always check your policy details for exact terms.",
      },
      {
        title: "What does the life insurance approval process involve?",
        description: "The approval process usually starts with completing an application, which includes personal information and health history. Insurers may conduct medical underwriting, which could involve a medical exam or reviewing medical records. Once assessed, you'll receive a decision on your coverage.",
      },
      {
        title: "What factors affect my premium rates?",
        description: "Premium rates are influenced by several factors, including your age, health status, lifestyle choices (such as smoking), and the coverage amount you select.",
      },
      {
        title: "Will my premiums increase during the term?",
        description: "With term life insurance, your premiums are typically fixed for the duration of the term you choose. However, if you renew your policy at the end of the term, your new premium will be based on your age and health at that time, which may result in an increase.",
      },
      {
        title: "What happens if I miss a premium payment?",
        description: "If you miss a premium payment, you may be given a grace period during which you can make the payment without losing coverage. If you fail to pay within that time, your policy could lapse.",
      },
      {
        title: "Can I change or add my beneficiary?",
        description: "Yes, you can change or add beneficiaries at any time during the policy term. It's important to keep this information up to date to ensure that your benefits go to the intended recipients.",
      },
      {
        title: "Can I convert my term policy to permanent insurance?",
        description: "Some term policies offer a conversion option, allowing you to switch to a permanent policy without undergoing further medical underwriting. Check with your insurer to see if this option is available.",
      },
      {
        title: "What if I am not a U.S. citizen or permanent resident?",
        description: "Many insurers do offer coverage for non-U.S. citizens or residents, but eligibility may vary by provider. You may need to provide additional documentation and meet certain requirements.",
      },
      {
        title: "Can I cancel my policy after it is issued?",
        description: "Yes, you can cancel your term life insurance policy at any time. It's advisable to review the cancellation terms in your policy documentation, as some insurers may have specific procedures or potential fees.",
      },
      {
        title: "Why do I need to provide my email address?",
        description: "Your email address is required for communication purposes, such as sending policy documents, quotes, and important updates. It helps ensure you receive timely information regarding your coverage.",
      },
    ]
  };
};